import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['pixels']
  static classes = ['pixel']

  #fired = new Set()

  track({ detail: { trackingUrl } }) {
    if (!this.hasPixelsTarget || !trackingUrl || this.#fired.has(trackingUrl)) return

    this.#fired.add(trackingUrl)
    this.#appendPixel(trackingUrl)
  }

  #appendPixel(url) {
    const img = document.createElement('img')
    img.src = url
    img.alt = ''
    img.classList.add(this.pixelClass)

    this.pixelsTarget.appendChild(img)
  }
}
